'use strict';

module Patersons {

    export class ConfigurationService extends BaseService {

        getValueByKey(key: string): ng.IHttpPromise<any> {
            return this.get("/dataService/odata/appconfigurations('" + key + "')");
        }
    }
}